import { DateTimeValue, DateValue } from "@/components/tableDrawer"

const TextCell = (accessor, header) => ({ Header: header || accessor, accessor: accessor, })
const SearchableTextCell = (accessor, header) => ({ ...TextCell(accessor, header), canSearch: true })
const HiddenSearchableText = (accessor, header) => ({ ...SearchableTextCell(accessor, header), visible: false })


const DateCell = (accessor, header) => ({ ...CustomCell(accessor || header, r => DateValue({value: r[accessor]})) })
const DateTimeCell = (accessor, header) => ({ ...CustomCell(accessor || header, r => DateTimeValue({value: r[accessor]})) })

const DateSearchableCell = (accessor, header) => ({ ...DateCell(accessor, header) , accessor: header || accessor, canSearch: true  ,type: "Date" })
const DateSearchableRangeCell = (accessor, header) => ({ ...DateSearchableCell(accessor, header), isMulti: true })

const HiddenDateSearchableCell = (accessor) => ({ ...DateSearchableCell(accessor) , visible: false })
const HiddenDateSearchableRangeCell = (accessor) => ({...HiddenDateSearchableCell(accessor) , isMulti: true  })


const DropDownCell = (accessor, probName, header, options, defaultValue) => ({
    Header: header || accessor,
    probName: probName || accessor,
    accessor: accessor,
    options: options,
    type: "DropDown",
    canSearch: true,
    defaultValue: defaultValue,
})

const DropDownMultiCell = (accessor, probName, header, options, defaultValue) => ({ ...DropDownCell(accessor, probName, header, options, defaultValue), isMulti: true })
const HiddenDropDownCell = (accessor, probName, header, options, defaultValue) => ({ ...DropDownCell(accessor, probName, header, options, defaultValue), isMulti: false, visible: false })
const HiddenDropDownMultiCell = (accessor, probName, header, options, defaultValue) => ({ ...DropDownMultiCell(accessor, probName, header, options, defaultValue), visible: false })



const CustomCell = (header, component) => ({ Header: header, Cell: ({ row: { original } }) => component(original) })


const CheckboxColumn = (HeaderCell, RowCell) => ({
    id: "select",
    Header: ({ getToggleAllPageRowsSelectedProps }) =>
        HeaderCell({ getToggleAllPageRowsSelectedProps }),
    Cell: ({ row }) => RowCell({ row })
})


export const ColumnsGenerator = {
    TextCell,
    SearchableTextCell,
    HiddenSearchableText,
    CustomCell,
    CheckboxColumn,

    DateCell,
    DateTimeCell,
    DateSearchableCell,
    DateSearchableRangeCell,
    HiddenDateSearchableCell,
    HiddenDateSearchableRangeCell,

    DropDownCell,
    DropDownMultiCell,
    HiddenDropDownCell,
    HiddenDropDownMultiCell,
}